<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "nuts-karhunkierros-2019-83km";
    let title = "Kokemuksia NUTS Karhunkierrokselta";
    let author = "Kari";
    let blogDate = "6.6.2019";
    let titlePic = "karhunkierros.jpg";
    let firstPara = "Kaikki alkoi jostain tyhmästä ideasta, joka alkoi pikkuhiljaa paisua. Lähteä nyt juoksemaan Karhunkierros, oletko ikinä kokeillut vaeltaa sitä, no en ole. Ja nyt se oli edessä. 83 km, hirvitti.";
</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            <p>{firstPara}</p>

            <p>
                Onneksi Maija ja Kirsi saivat hullun idean ja
                pidettiin Dynamo ULTRA, noin kuukausi ennen Karhunkierrosta. 5 x 12km juoksua,
                aina kolmen tunnin välein lähtö. Valoi uskoa tulevaan koitokseen tuo 60 km
                matkassa onnistuminen, en ole ikinä mennyt näin pitkästi.
            </p>
            <p>
                Markus oli testannut kaavojaan minuun pitkin
                kevättä ja hioimme juoksua sekä kuntoa, täyty jättää salihommat pois ei aika
                riitä, nyt juostaan. Parhaimmillaan juoksua tuli 70 km per viikko.
            </p>


            <b>Valmistelu</b>
            <p>
                Pieni flunssa iski muutama päivä ennen
                lähtöä, se tässä eniten pelotti miten tulee käymään. Minulla ei päällepäin
                flunssa näy. Huomaan sen olosta aamulla.
            </p>
            <p>
                Torstai ja perjantaiaamuista kaikki oli
                hyvin, joten rohkenin jatkaa valmisteluja. NUTS on lauantaina.
            </p>
            <p>
                Viikko olikin pakkaamista, perhe lähti etelän
                lämpöön En tiedä oliko prioriteetit kohdallaan, lähteä nyt Kuusamoon tai
                Kreetalle loikoilemaan. Lähdin Kuusamoon.
            </p>

            <p>Perjantaiaamulla otin kaikki kamat töihin ja
                lähtö töistä iltapäivästä. Meitä lähti Matti ja Heikki töistä 34 km matkalle,
                Elina siirsi eteenpäin. Matti on kovakuntoisin meistä ja tähtää syksyllä
                triatloniin. Nyt ensimmäistä kertaa polkujuoksutapahtumaan, sprintti matkalle.</p>
            <b>Ruka</b>
            <p>Noin 18:00 oltiin Rukalla, kamat mökkiin ja
                kisapaikalle hakemaan numerolappua ja jättämään Drop Bag järjestäjille. Laitoin
                geeliä ja muuta purtavaa, varavaatetta ja kengät Bag:iin.</p>
            <p>Minulla oli kaikki pakolliset varusteet
                mukana taskuissa. Sauvat kiinnitettynä juoksuliiviin, en halunnut sitä pakettia
                kantaa mukana, mutta halusivat välttämättä merkata juoksuliivin, joten ei muuta
                kuin takaisin mökille hakemaan liiviä.</p>
            <p>Lopulta sain kisanumeron, 605, ja
                tarvikkeita, Buffi huivi ja Polku lehti jäi ottamatta siinä tohinassa, no
                saahan niitä tarvittaessa kaupasta.</p>
            <p>Hieman varusteiden säätöä, juoksuhousut
                vaihtuivat kokopitkiksi talvimallin juoksuhousuiksi. Suunnittelin aluksi lähteä
                polven mittaisilla, mutta näytti tulevan kylmä ja sateinen päivä.
            </p>
            <p>Aikaisin petiin, tai meni se kymmeneen. 4:30
                herätys, sekä kellossa että puhelimessa. En normaalisti käytä herätystä niin
                tuon kanssa on aina säätämistä että toimiiko. Yö meni pyöriessä, aamuyöstä tuli
                kunnon unta.</p>
            <b>Herätys</b>
            <p>Kello ja
                puhelin pärähtivät yhtä aikaa soimaan, mitä nyt, ja hieman säätöä miten nämä
                sammutetaan. Aamupalaksi RiisiFrutti, kahvi, lisää kahvia ja banaani. Kamat
                niskaan ja liikenteeseen.
            </p>
            <p>Bussit olivat jo rivissä ja väkeä
                pyöri, kello oli 05:20, ei kuin kyytiin ja liikenteeseen saamantien, kohti
                lähtöpaikkaa Hautajärvellä.</p>
            <p>Viereen istu yksi Kemiläinen,
                törmäsin samaan heppuun myöhemmin myös polulla. Hän oli onnistunut laittaan
                herätyksen 00:30 ja oli keitellyt kahvia, kunnes kämppikset olivat ajaneet
                takaisin nukkumaan. </p>
            <p>Toinen säätö mitä oli
                tapahtunut, niin oli saanut puhelinnumeron mistä hakea mökin avaimet. Kuusamoon
                päästyä oli soittanut, niin avaimet Kemissä, melkein naapurissa. Sitten säätöä
                miten avaimet saa Kuusamoon.</p>
            <p>Katsoin kelloa, pulssi 108,
                tämähän lähtee hyvin, näin istuessa.</p>
            <b>Napapiiri</b>
            <p>Hautajärvellä oli vielä tilaa
                kun tultiin paikalle, sisälle rakennukseen ja sohvalle istumaan. Paikalla oli
                myös 166 km kisaajia odottamassa raatobussia, kovin vakavilta vaikuttivat.
                Olivat jo juosseet Rukalta Hautajärvelle, eli 83 km, loppu 166 km porukasta oli
                juoksemassa takaisin Rukalle. Huoltopisteillä on aikarajat, jotta saa jatkaa
                eteenpäin.</p>
            <p>Nopeasti siinä aika meni, ulos
                vielä tyhjennykselle ja odottelemaan lähtöä. Satoi vettä, kuoritakki päällä,
                ajattelin että saan ottaa sen jossain välissä pois kun alkaa lämpenemään, en ottanut.</p>
            <p>Väkeä oli, joku sanoi että 650
                henkeä olisi lähdössä 83:lle, tiedä oliko ihan noin paljon, mutta paljon oli.
            </p>

            <b>Lähtö</b>

            <p>Tuli kuulutus: ”30 sekuntia
                lähtöön” Hiimailin sopivaan väliin, kohtuullisen perälle, mutta ei aivan
                loppuun. Jos on liian edessä niin saa juosta kovaa ja jonon lopussa on pelkkää
                kävelyä. Lähtö torvet soivat, tunnelma katossa.</p>
            <p>Paikka tuli kohtuullisen
                sopivasti, mentiin sellaista 7:00 - 7:30 vauhtia letkassa. Kokoajan edellä
                menevän nilkkoja katsoessa, pitää keretä väistelemään juuria ja kiviä. Kompuroin
                mutta pysyn pystyssä.</p>
            <p>Alku on aina hieno, väkeä menee
                kuin pipoa, pitkä letka.</p>

            <b>Kohti luontokeskusta</b>

            <p>Ehkä noin 10km paikkeilla alkoi
                tulla enempi rakoa, pystyi menemään omaa vauhtia, syke 155, liian korkea,
                jonkin verran nyt porukkaa ohitti, mutta ajattelin että kyllä niitä selkiä
                tulee vielä vastaa.</p>
            <p>20km askel oli vielä keveä, ja
                polut hyvässä kunnossa. Kuuntelin takana tulevien juttuja, kuulosti olevan enemmänkin
                ultria suunnitteilla kesäksi, olivat Helsingistä.</p>
            <p>Sellainen huomio tuli itsestä,
                että juoksen mieluummin yksin kuin juttelen oudoille. Pieni erakko alkoi
                kaivautumaan esiin. Yhdessä välissä piti jättäytyä porukasta kun tuntui että ei
                tätä juttelua jaksa.</p>

            <b>2x500 mg Natriumkloridia</b>

            <p>Noin 30km ensimmäinen huolto ja
                Drop Bag, heitin tyhjät geelit kassiin ja liivi täyteen uutta energiaa. Olin
                ottanut geeliä n. 20min välein ja se tuntui hyvältä tahdilta. </p>
            <p>Hieman oli väsynyt ja kylmä
                olo. Kenkiä en vaihtanut, Altran kengät jalassa, 0-droppi. En ole 0-dropilla
                ultraa aikaisemmin juossut, joten hieman oli arvoitus pohkeille ja akillesjänteelle.
                Matka oli mennyt sen verran hyvin että jatkoin niillä. Salomoneissa olisi ollut
                kapeampi lesti ja pelkäsin varpaiden puristumista -&gt; rakkoja ja hiertymiä.</p>
            <p>Olen molemmat kengät hankkinut
                numeroa liian isona, jalka turpoaa, ja alkaa jossain vaiheessa ahdistamaan.
            </p>
            <p>Mandariinia ja lihalientä
                suuhun, olipa lihaliemi hyvää. Takavuosien 55 km jäi mandariinit mieleen, nyt
                lihaliemi. 2l juomapussi täyteen, pari suolatablettia. Suolatablettien
                hankkiminen, apteekista, mutta eivät tiedä mitä ne on, pitää ostaa ”500 mg Natriumkloriditabletteja”.</p>
            <p>Uudelleen liikenteeseen, lämmin
                tuli onneksi nopeasti kun pääsi juoksemaan.</p>

            <b>Se flow tiedättehän</b>

            <p>En tiedä mikä, mutta nyt kulki
                juoksu hyvin. Sai painaa rauhassa baanaa ja ohitella väkeä. Voisin jopa sanoa
                että oli flow päällä.</p>

            <p>Puhelimen käyttö oli hankalaa,
                kun tuli vettä koko ajan, näyttö ei toiminut ja sormet kohmeessa tai sitten
                sormikkaat kädessä, juurakkoa maassa. Aluksi ajattelin että laitan enemmänkin
                kuulumisia reitin varrelta, mutta ei pysty.</p>

            <p>Reitin varressa makasi nainen
                avaruushuopiin käärittynä, oli siisti paketti ja näytti liikkuvan, joten en
                jäänyt kyselemään. Oli varmaan jo saanut vastata 100 ihmiselle. Hommaan kuuluu,
                että kaveria ei jätetä. Helposti ollaan tarjoamassa energiaa ja apua jos joku
                vaikuttaa huonovointiselta.</p>

            <b>Muut matkat</b>

            <p>Reitti yhdistyy pieneen
                karhunkierrokseen ja 55km ja 34km juoksijoita alkaa tulemaan vastaan, pääsee
                ohittelemaan. Myös 166km, kovasti heitä kunnioittaen ohi.</p>
            <p>Törmäsin juoksijoihin joiden
                juttuja olin kuunnellut aikaisemmin, nyt menin ohi, jonkin ajan päästä
                ohittivat, sitten taas minä. Lopulta mies väsyi ja nainen jatkoi kovempaa
                vauhtia, minä perässä. </p>
            <p>50km täynnä. Vesi vähissä, Basecampiin
                7km (Juuman huoltopiste). Geeliä ilman vettä. Tuolla ei kauan mennä, puhalsin
                pussiin ja sieltä tulivat viimeset tipat. Lämmittää vähän aikaa, muttei kauan.
                Matkaa huoltopisteelle 2,5km joten ei paha. Haaveilin lihaliemestä.</p>

            <b>Basecamp</b>

            <p>Basecamp, ei ollut lihalientä,
                kokosin itseni ja aloin tankkaan. Tarjolla oli sipsiä, mandariinia, suklaata,
                urheilujuomaa, suolakurkkuja ja banaania. Pari mandariinia ja banaania naamaan,
                suolatabletit, veden täyttö ja matkaan.</p>

            <p>Nyt alkoi geeli etoa, 60km, askel oli edelleen “kevyt”, ei jumia tai suonenvetoja.
                Toki väsy, mutta pystyi juoksee. Polut olivat ihan paskana, 3000 ihmistä vesisateessa mennyt, joten kuraa,
                juurakkoja ja kiviä.</p>

            <b>Se on se geeli</b>

            <p>Nyt tuli vakavin vaurio
                vastaan, joku oli lyönyt päänsä ja talutettiin huoltoa kohti vastavirtaan,
                matkaa taisi olla 5km sinne. Varovaisuutta peliin, nyt ollaan pitkällä.</p>

            <p>Pulssi ei enää noussut, geeli
                alkoi tökkimään enempi, mutta mikään ei ollut niin varmaa kuin että tämä
                mennään loppuun. </p>

            <p>70km, vielä 7-8km niin
                viimeinen taukopaikka, ennen sitä on iso nousu. Mietin että otanko sauvat nyt
                käyttöön, ajattelin selvitä tämän vielä ilman ja huollossa irrotan sauvat
                käyttöön. Muut matkan nousut eivät niin haitanneet. </p>

            <p>Enää en juossut alamäkiäkkään,
                piti varmistaa että pääsee perille. Ja tasaista ei juurikaan ole tai se on
                juurakkoa/kivikko missä ei arvaa juosta.</p>

            <p>Alkumatkasta kompuroin paljon
                juuriin, mutta en kuitenkaan lentänyt nurin. </p>

            <p>Yksi nainen kenen perässä
                juoksin, jossain 20-30km kohdalla, hänellä oli pomppiva juoksutyyli ja kantapää
                ei käynyt maassa lainkaan, täytyy olla pohkeet terästä.</p>

            <b>Konttainen</b>

            <p>Viimeinen huolto, moni jää
                tähän. Nopeasti urheilujuomaa ja täytin geeli pullon myös sillä. Oli tuttuja
                naamoja reitiltä huollossa. Yksi t-paita päällä ja järjestäjät pakottaa
                laittamaan takin päälle. On kylmä tuulee ja sataa vettä.</p>

            <p>Väki kyselee raatobussia, osa
                avaruuslakanoissa odottamassa. Otin myös yhden geelin, väkisin. Enää 7km, mutta
                yhtä mäkeä, joko ylös tai alas. Ei kuin sauvomaan.</p>

            <b>Valtavaara</b>

            <p>Nyt vasta huomaa että pulssi ei
                nouse, juoksen 135 sykkeellä. Ajattelin että pystysipä tähän normaalistikki.
                Elimistössä tulee joku stoppi päälle, nipin napin 145 nousee ylämäessä.</p>

            <p>Selkää tulee vastaan enempi ja
                enempi, pääsen ohittelemaan. Suurin osa 34 ja 55 km juoksijoita.</p>

            <p>Kaikki meni hyvin kunnes
                viimeinen nousu, ei pystynyt pitää enää vauhtia, ja piti päästää porukkaa ohi
                jotka oli saavuttanut minut. Katsoin harmikseni että olivat samassa sarjassa.</p>

            <p>Taon mielessä, ei haittaa, olet
                tekemässä omaa suoritusta. Voittamassa itseäsi tai kääntäenhän tuo että
                häviämässä myös itselle. Kiitos Fingerpori tästä.</p>

            <b>Maali</b>

            <p>Lehmän kellot kuuluvat, ja
                kuulutus, FB live päälle ja maalia kohti. Nyt on mahtava fiilis. Heikki huutelee
                terassilta olut tuopin kanssa, ja Matti kannustaa maalisuoralla. Maalissa,
                mitali kaulaan ja ohjausta keittotelttaan.</p>

            <p>En kuitenkaan jäänyt keitolle,
                vaan suuntasin kohti mökkiä, askel keveä, mieli pilvissä, ja sauna on kuulemma
                lämmin.</p>

            <p>Puhelin hyytyi maalissa,
                ovikoodi on puhelimessa (Matti ja Heikki jäi vielä tori alueelle), muistista arvaus
                16283, osu ja pääsin sisään.</p>

            <p>
                Vaatteen päältä, kaikki märkänä
                ja rapakossa, juoda, suihkuun, lisää juotavaa ja energiaa. Tuumasin
                saunanlauteilla, juotavajugurtti mikä mainio sokeripommi.</p>

            <p>Puhelin laturiin ja SIM väärin,
                kolmesti, kyselee PUK koodia, hitto...</p>

            <b>Jälkipelit</b>

            <p>Jäi kyllä hyvä fiilis hommasta,
                geeleille pitää keksiä joten helpotusta, voisi kokeilla niitä vetisempiä
                ensikerralla.</p>

            <p>Koko päivän tuli vettä, mutta
                olihan kuoritakki hyvä. Onneksi hommasin sen juuri ennen reissua. Altra kengät,
                toimi vaikka kengillä alle 50 km juoksua takana aikaisemmin.</p>

            <p>Kaverit olivat ihan innoissaan
                omasta 34km juoksusta, ensivuonna kuulemma uudestaan 34:lle. Itsekin ajattelin
                että voisi ottaa sen 34:n uusiksi, se ei vaadi mitään suunnatonta treenaamista enää.</p>

            <p>Joku taisi mainita
                tunturimaratonin…</p>

            <b>Palautuminen</b>

            <p>Tänään on tiistai, 3
                päivää palautumista takana.</p>

            <p>Ensimmäinen yö meni
                hikoillessa ja toinen myös, lakanat märkänä.</p>

            <p>Etureidet ovat kipeät, toissapäivänä
                ne olivat tulessa. Keuhkot ja kurkku kipeänä. Nousi kuume toissa iltana. 4
                tunnin päästä homma oli ohi. Joku ihme.</p>

            <p>Ääni on nyt myös kuin tenorilla.
                Herättää hilpeyttä, saisin kuulemma alkaa vastaamaan työpaikan keskusnumeroon,
                mutta taitaa pian tulla 0700 alkuinen linja.
            </p>

            <p>Ruoka maistuu kuitenkin
                kohtuudella, ja palaudutaan. Ei rakkoja, kynnet tallessa. Pohkeet hellät, mutta
                eivät kipeät. Nähtävästi teen kaiken työn etureidellä. Pitää alkaa aktivoimaan
                pakaraa paremmin juoksuun.</p>

            <p>Askellus sopii pitkälle
                matkalle, ei nivelkipuja.</p>

            <p>Vaikka sanon että hauskaa oli,
                mutta ei se tarkoita että helppoa, 10 600 kcal, saa siihen vääntää. Homma onkin
                päästä kiinni enempi kuin kunnosta. Jos pitäisi laittaa järjestykseen niin: 1.
                pää, 2. tankkaus ja 3. kunto.</p>

            <p>Torstaina olisi luvassa muuttotalkoot, 3 kerros ei hissiä, hyvä palauttava treeni tiedossa.</p>
            <p>-Kari</p>


        </article>



        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='ranteiden_huolto' title='Muscle up renkaissa' titlePic='2018/muscleup_strip.jpg' blogDate='' firstPara='Muscle up, jota myös voimavedoksi sanotaan, on liike jossa urheilija punnertaa itsensä roikkumisasennosta renkaiden päälle rengaspitoon. Tässä artikkelissa käymme läpi muutamia vinkkejä liikkeen opettelemiseksi.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='2022-09-11_otevoima' title='Otteen ja puristusvoiman vahvistaminen' titlePic='2022/FatGripzMave2.jpg' blogDate='' firstPara='Hyvästä puristusvoimasta on hyötyä niin kuntosalilla kuin kotitöissä. Lue tästä vinkit otevoiman kehittämiseen.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='stressitomasti-tuloksiin' title='Stressittömästi tuloksiin' titlePic='riippumatto.jpg' blogDate='' firstPara='Meillä kaikilla on jokin syy motivaattorina, minkä vuoksi treenaamme - jos ja kun treenaamme. Jos haluat näkyviä tuloksia, tai vaikka treenaisit vain omaksi iloksesi tai puolisosi käskystä, kannattaa tämä lukea.'></BlogSummary>
                </article>
            </div>
        </section>

    

    </div>
{/if}

<style>


</style>